// Presale visibility flag.
// Flip PRESALE_VISIBLE to true to show the presale tier grid on the homepage AND
// to open /build/checkout/:slug to every logged-in account. While it is false,
// only admins and profiles with presale_tester = true can reach the checkout
// (v2.profiles.presale_tester, server-protected — set it with SQL, not the UI).
// Gate: Sales Agreement v3 executed and Lenore's review of this page (PLAN P1/P3).

export const PRESALE_VISIBLE = false;

// The Sales Agreement the buyer accepts at checkout (§16). Counsel's v3 of 2026-09-14,
// arbitration kept (founder ruling 9/16). Rendered at /sales-agreement from
// src/content/salesAgreement.ts; the page is gated like the checkout until PRESALE_VISIBLE.
// GUARDRAIL: the checkout refuses to render a Pay button when PRESALE_VISIBLE is
// true and this is null. If the agreement ever changes, bump SALES_AGREEMENT_VERSION too.
export const PRESALE_TERMS_URL: string | null = '/sales-agreement';

// Credits visibility flag.
// The credits balance on /profile and the /buy-credits page show dollar
// pricing to any phone-verified account — hidden until the pricing gate
// opens (same clearance as presale). Flip to true at launch.
export const CREDITS_VISIBLE = false;
